var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.dialogFormVisible
        ? _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogFormVisible, width: "600px" },
              on: {
                "update:visible": function($event) {
                  _vm.dialogFormVisible = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { width: "50%", margin: "0 auto 20px" } },
                [_vm._v(_vm._s(_vm.$i18n.t("common.BlackList")))]
              ),
              _c(
                "el-form",
                {
                  ref: "addUserBlackForm",
                  attrs: { model: _vm.addUserBlackData, rules: _vm.formRules }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "reason",
                        label: _vm.$i18n.t("common.reason"),
                        "label-width": "120px",
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          placeholder: _vm.$i18n.t("common.ReasonRequired"),
                          maxlength: "500",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.addUserBlackData.reason,
                          callback: function($$v) {
                            _vm.$set(_vm.addUserBlackData, "reason", $$v)
                          },
                          expression: "addUserBlackData.reason"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogFormVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$i18n.t("common.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addUserBlack }
                    },
                    [_vm._v(_vm._s(_vm.$i18n.t("common.confirm1")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }